export enum CoverageExclusionReason {
	NO_RECENT_DATA = 'no_recent_data',
	SUBSCRIPTION_EXPIRED = 'subscription_expired',
	OTHER = 'other',
}
